import useSWR from "swr";
import { apiUrls } from "../../utils/api";

export function useOrderCategories() {
  return useSWR(apiUrls.GetOrderCategories);
}
